import React from 'react';
import {
  ItemContainer,
  ItemContainerText,
  ItemContainerHeader,
  ItemContainerFooter,
} from '../../../components/Item';
import { Row, Col, InputGroup, Button } from 'reactstrap';
import Indicator, { IndicatorStateOptions } from '../../Indicator';
import InformationButton from '../../Item/InformationButton';
import Slider from 'rc-slider';
import 'rc-slider/assets/index.css';
import './index.css';
import ErrorField from '../../../containers/Fields/ErrorField';

export interface OptionItem {
  id: string;
  display: string;
  code: string;
  data: any;
  exclusive?: boolean;
}

export type SliderInputRenderProps = {
  supportingLink?: React.MouseEventHandler;
  informationText?: string[];
  indicatorState?: IndicatorStateOptions;
  text?: string;
  enabled?: boolean;
  error?: string;
  disabled?: boolean;
  name: string;
  check?: boolean;
  onBlur?: React.FocusEventHandler<HTMLInputElement>;
  onFocus?: React.FocusEventHandler<HTMLInputElement>;
  onChange?: React.ChangeEventHandler<HTMLInputElement>;
  value?: string;
  required?: boolean;
  options?: OptionItem[];
};

const getMarks = (options: OptionItem[]) => {
  const marks: { [key: string]: string } = {};
  options.forEach((opt, index) => {
    marks[index + 1] = opt.display;
  });
  return marks;
};

const SliderInput = (props: SliderInputRenderProps) => {
  const {
    text,
    enabled,
    supportingLink,
    informationText,
    indicatorState: state,
  } = props;
  const options = props.options ? props.options : [];
  const filtered = options.filter(f => !f.exclusive);
  const exclusive = options.find(opt => opt.exclusive);
  const isExclusive = exclusive && exclusive.code === props.value;
  const value = isExclusive
    ? 0
    : options.findIndex(opt => opt.code === props.value) + 1;
  const marks = getMarks(filtered);

  return enabled === undefined || enabled ? (
    <ItemContainer pulsing={enabled !== undefined}>
      <ItemContainerText text={text}>
        {supportingLink ? <InformationButton onClick={supportingLink} /> : null}
      </ItemContainerText>
      <ItemContainerHeader>
        <div className="d-flex flex-row-reverse justify-content-between">
          {informationText
            ? informationText.map((info, index) => (
                <div key={index} className={'d-inline-flex'}>
                  <em className={'i-information-text'}>{info}</em>
                </div>
              ))
            : null}
        </div>
      </ItemContainerHeader>
      <Row className="ic-item ic-slider m-2">
        <Col>
          <InputGroup>
            <Slider
              max={filtered.length}
              marks={marks}
              dots
              onChange={(value?: any) => {
                if (!props.onChange) return;
                if (!value) props.onChange(undefined as any);
                const option = filtered[value - 1] as any;
                if (option) {
                  props.onChange(option.code);
                }
              }}
              value={value < 0 ? 0 : value}
              disabled={props.disabled}
            />
          </InputGroup>
        </Col>
      </Row>
      <ItemContainerFooter>
        <div className="d-flex flex-row-reverse align-items-center ">
          <Indicator state={state} />
          {exclusive ? (
            <Button
              className="mr-3"
              color="info"
              outline
              active={isExclusive}
              onClick={() =>
                props.onChange
                  ? props.onChange(exclusive.code as any)
                  : undefined
              }>
              {exclusive.display}
            </Button>
          ) : null}
          <ErrorField name={props.name} />
        </div>
      </ItemContainerFooter>
    </ItemContainer>
  ) : null;
};
export default SliderInput;
